// Copyright 2020. Plesk International GmbH. All rights reserved.

import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/browser';
import './index.css';
import App from './components/App';

const { sentry, ...props } = window.__INITIAL_STATE__;
Sentry.init(sentry);

const root = createRoot(document.getElementById('root'));
root.render(<App {...props} />);
